/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import css from './index.module.scss';
import AddressList from './index.jsx';
const { fetchAddress } = Slices.addressSlice;
import { useNavigate } from '@reach/router';
import BackButton from '../../components/BackButton';
import MobileHeader from '../../components/Header/MobileHeader';
const { selectDesktop } = Slices.appSlice;
import LanguageButton from '../../components/LanguageButton';
import { FormattedMessage, useIntl } from 'react-intl';
import BackArrow from '../../components/Icons/BackArrow';

function Addresses({ action = '' }) {
  const [status, setStatus] = React.useState('initial');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  if (status === 'initial') {
    dispatch(fetchAddress());
    setStatus('loaded');
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className={css.root}>
        {!isDesktop ? (
          <MobileHeader
            title={<FormattedMessage id="profile_myaddresses" defaultMessage="My Addresses" />}
            actionButtons={[<LanguageButton />]}
          />
        ) : (
          <div className={css.header}>
            <div className={css.backArrow} onClick={handleBack}>
              <BackArrow />
            </div>
            <div className={css.mainHeading}>
              <FormattedMessage id="profile_myaddresses" defaultMessage="My Addresses" />
            </div>
            {/* <BackButton handleBack={handleBack} type="cross" /> */}
          </div>
        )}
        <AddressList myAddress={true} isDesktop={isDesktop} />
      </div>
    </>
  );
}

export default Addresses;
